/**
 * Parses a comma-separated string of sources and returns an array of trimmed, non-empty source strings.
 * For example, the input "scholar, slack, , news" would return ["scholar", "slack", "news"].
 */
export function getSourcesForQSources(sourcesValue) {
    return sourcesValue
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
}
//# sourceMappingURL=getSourcesForQSources.js.map